import CustomInput from "components/CustomInput/CustomInput";
import { Field, Form, Formik } from "formik";
import React, { useState, useReducer, useEffect } from "react";
import Modal from "react-responsive-modal";
import { useTeamContext } from "store/contexts/teamContext";
import TimelineService from "services/TimelineService";
import { useUserContext } from "store/contexts/userContext";
import { riddleState, riddleReducer } from "store/reducers/riddleReducer";
import { ReactComponent as RiddleIcon } from "assets/img/icons/riddle.svg";
import Loader from "components/Loader";
import * as Yup from "yup";
import PreviousRiddleResponses from "./PreviousRiddleResponses";

export default () => {
  const [
    {
      riddle,
      answer,
      id,
      submitting,
      previousRiddle,
      viewPrevious,
      isAnswered,
      reload,
    },
    dispatch,
  ] = useReducer(riddleReducer, riddleState);
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(false);
  const [noRiddle, setNoRiddle] = useState("");
  const { user } = useUserContext();
  const allowAnswer = false;
  const { team } = useTeamContext();
  const loaderStyle = {
    display: "flex",
    justifyContent: "center",
  };
  const initialValues = {
    riddle: "",
  };

  useEffect(() => {
    (async () => {
      try {
        var response = await TimelineService.getRiddle(team.id, user.id);
        dispatch({
          type: "setRiddleValue",
          value: {
            id: response?.data?.data?.riddle?.id,
            riddle: response?.data?.data?.riddle?.question,
            answer: response?.data?.data?.riddle?.answer,
            previousRiddle: response?.data?.data?.previous_answer,
            isAnswered: response?.data?.data?.riddle?.Answer,
          },
        });
      } catch (e) {
        if (e.response.data.status === 404) {
          setNoRiddle(true);
        }
      }
    })();

    return () => {
      setNoRiddle("");
    };
  }, [reload, team, user]);

  const viewAnswer = () => {
    setShow(!show);
  };

  const submitForm = async (value) => {
    try {
      const payload = {
        riddleId: id,
        teamId: team.id,
        answer: value.riddle,
      };
      dispatch({ type: "setSubmitting", value: true });
      await TimelineService.submitRiddleAnswer(payload, user.id);
      dispatch({ type: "setSubmitting", value: false });
      dispatch({ type: "setReload", value: !reload });
      setOpen(false);
    } catch (e) {
      console.log(e);
    }
  };

  if (!riddle && !noRiddle) {
    return null;
  }

  return (
    <div>
      <div className="riddleCard">
        {noRiddle && (
          <div className="noRiddle">There is no riddle added in team yet.</div>
        )}
        {!noRiddle && (
          <>
            <div className="riddleHeading">Riddle of the day</div>
            <div>{riddle}</div>
            {allowAnswer && (
              <div className="mt-1" onClick={viewAnswer}>
                {show && (
                  <div className="mt-1 mb-1">
                    <span className="riddleAnswerText">Answer:</span>
                    <span className="riddleAnswerText">{answer}</span>
                  </div>
                )}
                {!show && (
                  <button className="btn btn-dark btn-sm">View Answer</button>
                )}
              </div>
            )}
          </>
        )}
        {!noRiddle && (
        <div className="riddleActions pt-3">
        {isAnswered !== null && (
          <div
            className="riddleAnswerContent mt-0"
            style={{ fontSize: "11px" }}
          >
            <span className="riddleAnswerText">Your given answer:</span>
            <span className="riddleAnswerText" style={{ fontWeight: 400 }}>
              {isAnswered?.answer}
            </span>
          </div>
        )}
        {!isAnswered && (
          <div className="d-flex justify-content-end">
            <p
              style={{
                marginBottom: 0,
                color: "#212529",
                fontWeight: 500,
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => (isAnswered === null ? setOpen(true) : {})}
            >
              Submit Answer
            </p>
          </div>
        )}
        {previousRiddle && (
          <div className="d-flex justify-content-end">
            <p
              style={{
                marginBottom: 0,
                color: "#212529",
                fontWeight: 500,
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => {
                dispatch({ type: "setViewPrevious", value: true });
              }}
            >
              Previous Riddle
            </p>
          </div>
        )}
      </div>
        )}

      </div>
      <Modal
        center
        open={open}
        closeOnEsc={false}
        closeOnOverlayClick={false}
        styles={{
          modal: {
            maxWidth: "40%",
            width: "40%",
            borderRadius: "10px",
          },
        }}
        onClose={() => setOpen(false)}
      >
        <div className="riddleModalHeading">
          <h6>
            <span className="riddleModalHText">Riddle of the Day</span>
          </h6>
        </div>
        <div className="riddleModalContent">
          <span>{riddle}</span>
        </div>
        {isAnswered === null && (
          <Formik
            initialValues={initialValues}
            validationSchema={riddleSchema}
            onSubmit={(values, actions) => {
              submitForm(values);
            }}
          >
            <Form>
              <Field name="title">
                {({ field, form, meta }) => (
                  <>
                    <CustomInput
                      startIcon={<RiddleIcon className="riddleIcon" />}
                      inputProps={{
                        placeholder: "Write your answer",
                        value: field.riddle,
                        name: "riddle",
                        disabled: riddle.Answer ? true : false,
                        error:
                          !!form.errors.riddle && !!form.touched.riddle
                            ? form.errors.riddle
                            : null,
                      }}
                      inputClass="user-profile-inputs"
                      onChange={field.onChange}
                    />
                  </>
                )}
              </Field>
              <div className="riddleFooterButton d-flex justify-content-center">
                <button
                  type="submit"
                  style={{ width: "200px" }}
                  className="btn grad_btn"
                  disabled={submitting}
                >
                  {submitting ? (
                    <Loader loaderStyle={loaderStyle} width={25} height={25} />
                  ) : (
                    "submit"
                  )}
                </button>
              </div>
            </Form>
          </Formik>
        )}
      </Modal>

      <Modal
        center
        open={viewPrevious}
        closeOnEsc={false}
        closeOnOverlayClick={false}
        styles={{
          modal: {
            maxWidth: "35%",
            width: "35%",
            borderRadius: "10px",
          },
        }}
        onClose={() => {
          dispatch({ type: "setViewPrevious", value: false });
        }}
      >
        <div className="riddleModalHeading">
          <h6>
            <span className="riddleModalHText">Riddle of the previous day</span>
          </h6>
        </div>
        <div className="mt-3">
          <h6 className="previousRiddleContent">
            <strong>Question:</strong> {previousRiddle?.question}
          </h6>
          <h6 className="mt-1 mb-1 previousRiddleContent">
            <strong>Answer: </strong>
            {previousRiddle?.answer}
            <PreviousRiddleResponses
              responses={previousRiddle?.previous_riddle_response ?? []}
            />
          </h6>
        </div>
      </Modal>
    </div>
  );
};

const riddleSchema = Yup.object().shape({
  riddle: Yup.string().trim().required("Please add your answer."),
});
